export default __webpack_public_path__ + "static/media/threeD.eae18ac5.gif";